import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { fetchDeploymentsApi } from '../../api/sandbox.api';
import { useI18n } from '../../hooks/useI18n';

const hasActiveDeployment = (deployments) =>
  deployments.some((deployment) => (deployment.status || '').toLowerCase() === 'active');

export const PublicProjectDeploymentWarning = ({ projectId, isPublic }) => {
  const { t } = useI18n();
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (!isPublic || !projectId) {
      setShowWarning(false);
      return undefined;
    }

    let cancelled = false;

    fetchDeploymentsApi({ projectId })
      .then((deployments) => {
        if (!cancelled) {
          setShowWarning(!hasActiveDeployment(deployments));
        }
      })
      .catch(() => {
        if (!cancelled) {
          setShowWarning(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [isPublic, projectId]);

  if (!isPublic || !showWarning) {
    return null;
  }

  const deploymentsPath = `/workspace/${projectId}/deployments`;

  return (
    <div className="shrink-0 px-3 py-2">
      <div
        role="alert"
        className="flex flex-wrap items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100"
      >
      <AlertTriangle size={18} className="mt-0.5 shrink-0" aria-hidden />
      <p className="min-w-0 flex-1 leading-6">
        {t('workspacePublicDeploymentWarning')}{' '}
        <Link className="font-semibold underline underline-offset-2 hover:opacity-80" to={deploymentsPath}>
          {t('workspacePublicDeploymentWarningLink')}
        </Link>
      </p>
      </div>
    </div>
  );
};
